export const colleges = [
  "Atharva College of Engineering",
  "Bhagwan Parshuram Institute of Technology",
  "University of Petroleum and Energy Studies",
  "Ashoka University",
  "Indian Institute of Information Technology Sri City",
  "DAV Institute of Engineering & Technology",
  "Lovely Professional University",
  "Somaiya Vidyavihar",
  "NorthCap University",
  "Dharamsinh Desai University",
  "University of Health Sciences Andhra Pradesh",
  "Allahabad Agricultural Institute, Deemed University",
  "Assam Agricultural University",
  "Ahmedabad University",
  "All India Institute of Medical Sciences",
  "AISECT University",
  "Alagappa University",
  "Allahabad University",
  "Open International University for Alternative Medicines",
  "Indian Board of Alternative Medicine",
  "Amity University",
  "Amrita Vishwa Vidyapeetham",
  "Amravati University",
  "Aligarh Muslim University",
  "Andhra University",
  "Acharya Ranga Agricultural University",
  "Annamalai University",
  "Anna University of Technology, Tirunelveli",
  "Anna University",
  "Awadhesh Pratap Singh University",
  "ARYA Institute of Engineering & Technology",
  "Assam University",
  "Gujarat Ayurved University",
  "Dr. Babasaheb Ambedkar Marathwada Universtiy",
  "Berhampur University",
  "Banasthali University",
  "Bankura University",
  "Birsa Agricultural University",
  "Babasaheb Bhimrao Ambedkar University",
  "Bidhan Chandra Agricultural University",
  "Bharathidasan University",
  "Bengal Engineering College",
  "Bangalore University",
  "Bhagwant University",
  "Bharathiar University",
  "Bharath Institue Of Higher Education & Research",
  "Bharati Vidyapeeth University",
  "Bhavnagar University",
  "Banaras Hindu University",
  "Orissa University of Agriculture and Technology",
  "Birla Institute of Technology, Ranchi",
  "Birla Institute of Technology and Science",
  "Bhupendra Narayan Mandal University",
  "Biju Pattnaik University of Technology",
  "B. R. Ambedkar Bihar University",
  "Dr. B.R. Ambedkar Open University",
  "Dr. B. R. Ambedkar National Institute of Technology Jalandhar",
  "Dr. Bhim Rao Abdekar University",
  "B. S. Abdur Rahman University",
  "Barkatullah University",
  "VIT Bhopal",
  "Bundelkhand University",
  "University of Burdwan",
  "University of Calcutta",
  "Central Agricultural University",
  "Chaudhary Charan Singh University",
  "Ch. Charan Singh University",
  "Center for Entrepreneurship and Small Business Management",
  "Christ University",
  "Central Institute of English and Foreign Languages",
  "Central Institute of Fisheries Education",
  "Central Institute of Higher Tibetan Studies",
  "CMJ University",
  "Chandra Shekhar Azad University of Agriculture and Technology",
  "Cochin University of Science and Technology",
  "Dr. C.V. Raman University",
  "Dhirubhai Ambani Institute of Information and Communication Technology",
  "Darul Huda Islamic University",
  "Dav University",
  "Devi Ahilya University of Indore",
  "Dr. Babasaheb Ambedkar Technological University",
  "Konkan Agricultural University",
  "Tamil Nadu Agricultural University",
  "Delhi College of Engineering (DCE)",
  "Deen Dayal Upadhyay Gorakhpur University",
  "Deccan College Postgraduate and Research Institute",
  "COEP Technological University",
  "Dayalbagh Educational Institute",
  "Dibrugarh University",
  "Dravidian University",
  "University of Delhi",
  "Dr. D.Y. Patil University",
  "Eiilm University",
  "Fatima Mata National College",
  "Forest Research Institute Dehradun",
  "Govind Ballabh Pant University of Agriculture and Technology",
  "Guru Ghasidas University",
  "Gokhale Institute of Politics and Economics",
  "Gandhi Institute of Technology and Managment",
  "Guru Jambeshwar University",
  "Gurukula Kangri University",
  "Guru Nanak Dev University",
  "Global Open University , Nagaland",
  "Gujarat Technological University Ahmedabad",
  "Gujarat University Ahmedabad",
  "Gulbarga University",
  "Gauhati University",
  "Gurukul University",
  "CCS Haryana Agricultural University",
  "Himachal Pradesh Agricultural University",
  "Hemwati Nandan Bahuguna Garhwal University",
  "Hidayatullah National Law University, Raipur",
  "Sri Ramachardra Medical College and Research Institute",
  "Himachal Pradesh University",
  "Indian Agricultural Research Institute",
  "IASE (Institute of Advanced Studies) Deemed University",
  "ICFAI University",
  "ICFAI University, Dehradun",
  "ICFAI University, Tripura",
  "ICFAI University, Sikkim",
  "ICFAI University, Mizoram",
  "ICFAI University, Meghalaya",
  "ICFAI University, Jharkhand",
  "ICFAI University, Nagaland",
  "ICFAI University, Jaipur",
  "ICFAI University, Raipur",
  "ICFAI University, Himachal Pradesh",
  "ICFAI University, Hyderabad",
  "Indira Gandhi Agricultural University",
  "Indira Gandhi Institute of Development and Research",
  "Indira Gandhi Institute of Medical Sciences",
  "Indira Gandhi National Open University",
  "Indian Institute of Information Technology Allahabad",
  "Indian Institute of Information Technology and Management - Kerala",
  "Indraprastha Institute of Information Technology, Delhi",
  "International Institute of Information Technology, Pune",
  "International Institute of Information Technology, Bhubaneswar",
  "International Institute of Information Technology, Bangalore",
  "Indian Institute of Management, Tiruchirappalli",
  "Indian Institute of Information Technology, Guwahati",
  "Indian Institute of Information Technology, Vadodara",
  "Indian Institute of Information Technology, Kota",
  "International Institute for Population Sciences",
  "Indian Institute of Science",
  "Indian Institute of Technology, Bombay",
  "Indian Institute of Technology, Delhi",
  "Indian Institute of Technology, Gandhinagar",
  "Indian Institute of Technology, Guwahati",
  "Indian Institute of Technology, Hyderabad",
  "Indian Institute of Technology, Kanpur",
  "Indian Institute of Technology, Kharagpur",
  "Indian Institute of Technology, Madras",
  "Madras Institute of Technology",
  "Indian Institute of Technology, Roorkee",
  "Indian Institute of Technology, Patna",
  "Indian Institute of Technology, Indore",
  "Indian Institute of Technology, Jodhpur",
  "University of Music and Fine Arts",
  "Indian Law Institue",
  "Indus University",
  "Integral University",
  "Guru Gobind Singh Indraprastha University",
  "Indian School of Business Management and Administration",
  "Indian Statistical Institute",
  "Indian School of Mines (ISM)",
  "Institute of Technology and Management",
  "Indian University",
  "Indian Veterinary Research Institute",
  "Jadavpur University",
  "First Global University to teaching Jainism",
  "Jamia Hamdard University",
  "University of Jammu",
  "Jaypee Institute of Information Technology",
  "Jiwaji University",
  "Jamia Millia Islamia University",
  "Jawaharlal Nehru Centre for Advanced Scientific Research",
  "Jawaharlal Nehru Agricultural University",
  "Jawaharlal Nehru Technological University Hyderabad",
  "Jawaharlal Nehru University",
  "Jaipur National University",
  "Jodhpur National University",
  "Jai Prakash University",
  "Rajasthan Vidyapeeth University",
  "Jain Vishva Bharati Institute",
  "Kalinga University",
  "Sri Chandrasekharendra Saraswathi Viswa Mahavidyalaya",
  "Kannada University",
  "Kannur University",
  "Chhatrapati Shahu Ji Maharaj University",
  "Kanpur University",
  "Karnataka State Open University",
  "Karpagam University",
  "Karunya Institute Of Technology",
  "University of Kashmir",
  "Kerala Agricultural University",
  "University of Kerala",
  "Kohinoor School of Hospitality Management",
  "University of Kalyani",
  "Krishna University",
  "Kameshwar Singh Darbhanga Sanskrit University",
  "Karnataka State Law University",
  "Karnatak University",
  "Kerala University of Fisheries and Ocean Sciences",
  "Kurukshetra University",
  "Kumaraguru College of Technology",
  "Kumaun University",
  "Kuvempu University",
  "Kakatiya University",
  "L.D.College of Engineering",
  "Lakshmibai National Institute of Physical Education",
  "Lalit Narayan Mithila University",
  "University of Lucknow",
  "Mar Athanasios College for Advanced Studies",
  "Magadh University",
  "Mangalore University",
  "Manipal University",
  "Manipur University",
  "Moulana Azad national Urdu University",
  "Makanlal Chutur Vedi University",
  "Maharshi Dayanand Sarswati University Ajmer",
  "Maharishi Dayanand University, Rohtak",
  "Mahatma Gandhi Kashi Vidyapith",
  "Maharaja Ganga Singh University, Bikaner",
  "Mahatma Gandhi University, Kerala",
  "Mahatma Jyotiba Phule Rohilkhand University Bareilly",
  "Madurai Kamaraj University",
  "Marathwada Agricultural University",
  "Mohan Lal Sukhadia University",
  "Motilal Nehru National Institute Of Technology",
  "Madhya Pradesh Bhoj (Open) University",
  "Mahatma Phule Agricultural University",
  "Maharaja Sayajirao University of Baroda",
  "University of Mumbai",
  "Acharya Nagarjuna University",
  "Nagaland University",
  "Nagpur University",
  "Nalanda Open University",
  "National Museum Institute of History of Art, Conservation and Museology",
  "University of North Bengal",
  "National Dairy Research Institute",
  "Narendra Deva University of Agriculture and Technology",
  "North Eastern Hill University",
  "Hemchandracharay North Gujarat University",
  "National Institute of Mental Health and Neuro Sciences",
  "Nizam's Institute of Medical Sciences",
  "Institute of Management Studies",
  "Nirma University",
  "National Institute of Industrial Engineering",
  "National Institute of Technology Agartala",
  "National Institute of Technology Andhra Pradesh",
  "National Institute of Technology Arunachal Pradesh",
  "National Institute of Technology Calicut",
  "National Institute of Technology Delhi",
  "National Institute of Technology Durgapur",
  "National Institute of Technology Goa",
  "National Institute of Technology Hamirpur",
  "National Institute of Technology Jamshedpur",
  "National Institute of Technology Kurukshetra",
  "National Institute of Technology Manipur",
  "National Institute of Technology Meghalaya",
  "National Institute of Technology Mizoram",
  "National Institute of Technology Nagaland",
  "National Institute of Technology Patna",
  "National Institute of Technology Puducherry",
  "National Institute of Technology Raipur",
  "National Institute of Technology Rourkela",
  "National Institute of Technology Sikkim",
  "National Institute of Technology Silchar",
  "National Institute of Technology Srinagar",
  "National Institute of Technology Surathkal",
  "National Institute of Technology Trichy",
  "National Institute of Technology Uttarakhand",
  "National Institute of Technology Warangal",
  "National Law School of India University",
  "Narsee Monjee Institute of Management Studies",
  "North Maharashtra University",
  "Netaji Subhas University of Technology",
  "Osmania University",
  "Sri Padmavati Women's University",
  "Pandit Deendayal Energy University",
  "Punjab Agricultural University",
  "Dr. Panjabrao Deshmukh Krishi Vidyapeeth",
  "Parul University",
  "Punjab Engineering College",
  "PES University",
  "Postgraduate lnstitute of Medical Education and Research",
  "Pondicherry University",
  "PSG College of Technology",
  "Jai Narain Vyas University",
  "Punjab Technical University",
  "Panjab University",
  "Punjabi University Patiala",
  "Patna University",
  "Rajendra Agricultural University",
  "Rabindra Bharati University",
  "Ranchi University",
  "Rajasthan Agricultural University, Bikaner",
  "Rani Durgavati University",
  "Rajiv Gandhi Technical University (University of Technology of Madhya Pradesh)",
  "Rajiv Gandhi University",
  "Rajitlal Institute of Technology & Health Sciences (RITHS)",
  "Dr. Ram Manohar Lohia Avadh University",
  "Pandit Ravi Shankar Shukla University",
  "Rajasthan Technical University",
  "Mahatma Gandhi Chitrakut Gramoday University",
  "Dr. Hari Singh Gour University, formerly University of Sagar",
  "Sambalpur University",
  "National Sanskrit University",
  "SASTRA University",
  "Sathyabama University",
  "Saurashtra University",
  "Sree Chitra Tirunal Institute for Medical Sciences and Technology",
  "Sardarkrushinagar Dantiwada Agricultural University",
  "Sanjay Gandhi Postgraduate lnstitute of Medical Sciences",
  "South Gujarat University",
  "Shobhit University, Meerut",
  "Shridhar University",
  "Vikrama Simhapuri University",
  "Symbiosis International University",
  "Shri Jagannath Sanskrit University",
  "Sido Kanhu Murmu University",
  "Sher-E-Kashmir University of Agricultural Sciences and Technology",
  "Sri Krishnadevaraya University",
  "Shri Lal Bahadur Shastri Rashtriya Sanskrit Vidyapeetha",
  "SMK Fomra Institute of Technology",
  "Sikkim Manipal University of Health, Medical and Technological Sciences",
  "Shreemati Nathibai Damodar Thackersey Women's University",
  "Sikha 'O' Anushandhan University",
  "South Asian University",
  "School of Planning and Architecture",
  "Periyar University",
  "Sardar Patel University",
  "Sri Sathya Sai Institute of Higher Learning",
  "Sree Rama Krishna Degree College",
  "SRM Institute Of Science & Technology",
  "Swami Ramanand Teerth Marathwada University",
  "Sri Sant Gajanan Maharaj College of Engineering",
  "Sree Sankaracharya University of Sanskrit",
  "Sampurnanand Sanskrit University",
  "Solapur University",
  "Sardar Vallabhai Patel University of Agriculture Amd Technology",
  "Sardar Vallabhbhai National Institute of Technology",
  "Sri Venkateswara Institute of Medical Sciences",
  "Sri Venkateswara University",
  "Tamil University",
  "Tamil Nadu Veterinary and Animal Sciences University",
  "Thiagarajar College of Engineering",
  "Potti Sreeramulu Telugu University",
  "Tezpur University",
  "The New College",
  "Thapar Institute of Engineering and Technology",
  "Tata Institute of Social Sciences",
  "Tilka Manjhi Bhagalpur University",
  "Tilak Maharashtra Vidyapeeth",
  "Tamil Nadu Dr. Ambedkar Law University",
  "Tamil Nadu Dr. M.G.R. Medical University",
  "Avinashilingam Institute for Home Science and Higher Education for Women",
  "Maulana Azad National Institute of Technology Bhopal",
  "Malaviya National Institute of Technology Jaipur",
  "Tripura University",
  "Takhatmal Shrivallabh Homoeopathic Medical College",
  "Tumkur University",
  "Thiruvalluvar University",
  "University of Agricultural Sciences, Bangalore",
  "University of Agricultural Sciences, Dharwad",
  "Uttarakhand Technical University",
  "University of Media Arts",
  "University of Calicut",
  "Goa University",
  "University of Mysore",
  "University of Pune",
  "University of Rajasthan",
  "Shivaji University",
  "University of Madras",
  "University of Hyderabad",
  "University of Kota",
  "University of Roorkee",
  "Uttarakhand Open University",
  "Uttar Pradesh Technical University",
  "Utkal University",
  "VBS Purvanchal University",
  "Vinoba Bhave University",
  "Vidyasagar University",
  "Vignan University",
  "Vikram University",
  "Vinayaka Mission's Research Foundation-Deemed University",
  "Visva-Bharati University",
  "Vellore Institute of Technology",
  "Veer Kunwar Singh University",
  "Vardhaman Mahaveer Open University",
  "Visvesvaraya National Institute of Technology",
  "Veer Surendra Sai University of Technology",
  "Visvesvaraya Technological University",
  "West Bengal University of Animal and Fishery Sciences",
  "West Bengal University of Technology",
  "Yashawantrao Chavan Maharashtra Open University",
  "Dr. YS Parmar University of Horticulture and Forestry",
  "Charotar University of Science and Technology",
  "Navrachana University",
  "Atal Bihari Vajpayee Indian Institute of Information Technology and Management, Gwalior",
  "COER University Roorkee",
  "IIT Bhubaneswar",
  "SRM University",
  "KIET Group of Institutions",
  "Ramaiah University of Applied Sciences",
  "Uttaranchal University",
  "University College, Thiruvananthapuram",
  "GSFC University",
  "Anurag University",
  "Bishop Herber College",
  "Pondicherry University",
  "Panimalar Engineering College",
  "Rajalakshmi Engineering College",
  "Rajagiri School of Engineering and Technology",
  "St Joseph's College Of Engineering",
  "St Joseph's Institute Of Technology",
  "Sri Sivasubramaniya Nadar Institutions",
  "Saveetha Engineering College",
  "Sri Venkateswara College of Engineering",
  "Easwari Engineering College",
  "Jeppiar Engineering College",
  "Rajalakshmi Institute of Technology",
  "Saveetha School of Engineering",
  "Saveetha University",
  "KCG College of Technology",
  "Hindustan Institute of Technology and Science",
  "Chennai Institute of Technology",
  "Sri Sai Ram Engineering College",
  "Loyola-ICAM College of Engineering and Technology",
  "Sri Sai Ram Institute of Technology",
  "RMK Engineering College",
  "RMK College of Engineering and Technology",
  "RMD Engineering College",
  "Velammal Engineering College",
  "Velammal Institute of Technology",
  "Prathyusha Engineering College",
  "Alpha College of Engineering",
  "SA Engineering College",
  "Sister Nivedita University",
  "JIS University",
  "JIS College of Engineering",
  "Narula Institute of Technology",
  "Guru Nanak Institute of Technology",
  "Guru Nanak Institute of Hotel Management",
  "Guru Nanak Institute of Pharmaceutical Science & Technology",
  "Guru Nanak Institute of Dental Sciences & Research",
  "Dr. Sudhir Chandra Sur Institute of Technology & Sports Complex",
  "JIS Institute of Advanced Studies & Research",
  "JIS School of Medical Science & Research",
  "JIS Institute of Pharmacy",
  "JIS School of Polytechnic",
  "Greater Kolkata College of Engineering & Management",
  "Chandil Polytechnic School",
  "Gola Polytechnic School",
  "Asansol Engineering College",
  "Aditya University",
  "Assam Down Town University",
  "Kalinga Institute of Industrial Technology (KIIT)",
  "Sharda University",
  "Shri Jagdishprasad Jhabarmal Tibrewala University",
  "Singhania University",
  "Manav Rachna University",
  "MIT World Peace University",
  "Technique Polytechnic Institute",
  "Indian Institute Of Technology–Ropar (IIT–Ropar)",
  "Kaloji Narayana Rao University of Health Sciences",
  "Mahatma Gandhi University, Nalgonda",
  "Nizam's Institute of Medical Sciences",
  "Palamuru University",
  "Professor Jayashankar Telangana State Agricultural University",
  "P. V. Narasimha Rao Telangana Veterinary University",
  "Satavahana University",
  "Sri Konda Laxman Telangana State Horticultural University",
  "Telangana University"
];